// One feature request in full (2026-09-27): the request, the member, the
// status with who and when, the staff note, and the history of every
// change. Members are not written back to (founder 2026-09-27).
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Loader from "../child/Loder";
import DengerAlert from "../child/Alert/DengerAlert";
import { handleUnauthorized } from "../../utils/apiHelper";
import moment from "moment";
import { fetchFeatureRequestById } from "../services/featureRequest";
import { StatusPill, labelFor, STATUSES } from "./FeatureRequestList";

const who = (by) => String(by || "admin").split("@")[0];

const ViewFeatureRequestPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [request, setRequest] = useState(null);
  const [statuses, setStatuses] = useState(STATUSES);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    fetchRequest();
    // eslint-disable-next-line
  }, [id]);

  const fetchRequest = async () => {
    setLoading(true);
    try {
      const { data } = await fetchFeatureRequestById(id);
      setRequest(data?.data);
      if (Array.isArray(data?.statuses) && data.statuses.length) setStatuses(data.statuses);
    } catch (err) {
      if (err.response?.status === 401) {
        handleUnauthorized(navigate);
        return;
      }
      setErrorMessage(err.response?.data?.message || err.message);
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;

  const member = request?.member || {};
  const platform = request?.platform === "ios" ? "iOS" : request?.platform || "N/A";
  const when = (d) => (d ? moment(d).format("DD-MM-YYYY, hh:mm A") : "N/A");
  const history = Array.isArray(request?.history) ? [...request.history].reverse() : [];

  return (
    <div className="row gy-4">
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            {errorMessage && (
              <DengerAlert message={errorMessage} onClose={() => setErrorMessage("")} />
            )}

            <div className="d-flex align-items-start justify-content-between flex-wrap gap-3 mb-20">
              <div>
                <h5 className="fw-semibold mb-1">{request?.title || "N/A"}</h5>
                <div className="text-secondary-light">
                  {member.firstName || request?.userId?.email || "Member"}
                  {member.city ? `, ${member.city}` : ""}
                  {" asked "}
                  {request?.createdAt ? moment(request.createdAt).fromNow() : "N/A"}
                  {" from "}
                  {platform}
                  {request?.appVersion ? ` ${request.appVersion}` : ""}
                </div>
              </div>
              <div className="text-end">
                <StatusPill value={request?.status} statuses={statuses} />
                <div className="text-xs text-secondary-light mt-1">{request?.stamp || ""}</div>
                {request?.status === "released" && request?.shippedIn && (
                  <div className="text-xs text-secondary-light">Build {request.shippedIn}</div>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-md-8 mb-3">
                <label className="form-label fw-bold">What they wrote</label>
                <div style={{ whiteSpace: "pre-wrap" }}>{request?.description || "N/A"}</div>
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label fw-bold">Member</label>
                <div>{request?.userId?.email || "N/A"}</div>
                {member.joinedAt && (
                  <div className="text-secondary-light text-sm">Joined {moment(member.joinedAt).format("DD-MM-YYYY")}</div>
                )}
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label fw-bold">Internal note (staff only)</label>
                <div style={{ whiteSpace: "pre-wrap" }} className={request?.internalNote ? "" : "text-secondary-light"}>
                  {request?.internalNote || "None."}
                </div>
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label fw-bold">History</label>
                {history.length === 0 ? (
                  <div className="text-secondary-light">
                    {request?.status && request.status !== "new"
                      ? `${labelFor(request.status, statuses)} was set before changes were recorded.`
                      : "No status change yet."}{" "}
                    Written {when(request?.createdAt)}.
                  </div>
                ) : (
                  <ul className="list-unstyled mb-0">
                    {history.map((h, i) => (
                      <li key={i} className="py-2 border-bottom">
                        <StatusPill value={h.status} statuses={statuses} />{" "}
                        <span className="text-secondary-light text-sm">
                          {when(h.at)} by {who(h.by)}
                        </span>
                      </li>
                    ))}
                    <li className="py-2 text-secondary-light text-sm">Written {when(request?.createdAt)}</li>
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewFeatureRequestPage;
